import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserSelectorComponent} from './user-selector.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserSelectorService} from './user-selector.service';
import {EePipesModule} from '@ee/common/pipes';
import {TippyDirective} from '@ngneat/helipopper';


@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, EePipesModule, TippyDirective],
  declarations: [UserSelectorComponent],
  providers: [UserSelectorService],
  exports: [UserSelectorComponent]
})
export class UserSelectorModule {}
